module.exports = __webpack_public_path__ + "media/images/icon_next-c0be12742999791aec3ed87bb131938f.svg";